import { OdataManager } from '@/api/odata/odata-manager';
import { PnrDocumentType } from '@/api/model/interfaces';

export default class PnrDocumentTypeOdata extends OdataManager<PnrDocumentType> {}
